<div class="flex flex-col h-full bg-white overflow-hidden">
  <!-- En-tête -->
  <div class="shrink-0 h-[88px] border-t border-b border-gris-3 grid grid-cols-[1fr_auto_1fr] px-5 items-center">
    <button type="button" (click)="goBack()"
      class="justify-self-start border border-gris-3 rounded-[5px] h-[58px] px-5 flex items-center gap-[10px] fg-noir-2 text-[16px] font-medium cursor-pointer hover:bg-gris-4 transition-colors">
      <app-svg class="fg-gris-1 shrink-0" height="20" svgPath="assets/svg/arrow-back.svg" width="20" />
      {{ 'common.back' | translate }}
    </button>

    <span class="text-[20px] font-semibold fg-noir-2 justify-self-center">
      {{ 'order_detail.title' | translate }}
    </span>
  </div>

  <!-- Contenu principal -->
  <main class="flex-1 p-5 overflow-hidden">
    @if (sessionOrder(); as item) {
    <div class="bg-gris-4 rounded-[10px] h-full flex flex-col overflow-hidden border border-gris-3">
      <!-- Infos client & statut -->
      <div class="flex items-center justify-between px-5 pt-5 pb-[15px] shrink-0">
        <div class="flex items-center gap-[15px] min-w-0">
          <div class="size-[10px] rounded-full shrink-0" [class]="getStatusClass(item.order.status)"></div>
          <div class="flex flex-col min-w-0">
            <span class="text-[20px] font-semibold fg-noir-2 leading-tight truncate">
              {{ item.user.firstname + ' ' + item.user.lastname }}
            </span>
            <span class="text-[14px] fg-gris-1 leading-tight truncate">
              #{{ item.user.badge_number ?? '—' }} · {{ item.order.mealmoment.name }} ·
              {{ item.order.created_at | date: 'HH:mm' }} ·
              {{ getPaymentMode(item.order.payments) }}
            </span>
          </div>
        </div>

        <span
          class="inline-flex items-center justify-center px-[20px] h-[41px] rounded-[30px] text-[16px] font-semibold text-white shrink-0"
          [class]="getStatusClass(item.order.status)">
          {{ 'order_list.status.' + item.order.status | translate }}
        </span>
      </div>

      <!-- Annulation / validation / forçage -->
      @if (statusNote(); as note) {
      <div class="px-5 pb-[15px] shrink-0">
        <span class="text-[14px]" [class.fg-rose-1]="note.isAlert" [class.fg-gris-1]="!note.isAlert">
          {{ note.text }}
        </span>
      </div>
      }

      <!-- Liste des produits -->
      <div class="flex-1 overflow-y-auto mx-5 grid grid-cols-4 gap-[10px] auto-rows-min">
        @for (orderItem of item.order.order_items; track orderItem.id) {
        <app-summary-course-card [course]="getCourseFromOrderItem(orderItem)" [serviceName]="orderItem.service.name"
          [showPrice]="shouldShowPrice(item.order, orderItem)" [showRemoveButton]="false"
          [quantity]="orderItem.quantity"
          [imageUrl]="orderItem.service.image" [bgColor]="getBgColorFromOrderItem(orderItem)" />
        }

        @if (item.order.order_items.length === 0) {
        <div class="col-span-4 flex items-center justify-center py-[40px]">
          <span class="text-[16px] fg-gris-1">{{ 'order_detail.empty' | translate }}</span>
        </div>
        }
      </div>

      <!-- Total -->
      <div
        class="shrink-0 flex items-center justify-between px-5 py-[15px] mx-5 my-5 bg-white border border-gris-3 rounded-[5px]">
        <span class="text-[16px] font-semibold fg-noir-2">
          {{ 'order_detail.total' | translate }}
        </span>
        <span class="text-[19px] font-bold fg-vert-1">{{ item.order.price | formatPrice }}</span>
      </div>
    </div>
    }
  </main>
</div>